module.exports = __webpack_public_path__ + "img/DrawKit Vector Illustration Landscape & Scenery (5).c4f46870.svg";